export const fechaCotizacion = (value: string): string => {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
    const [year, month, day] = value.split('-').map(Number);
    const months = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sept', 'oct', 'nov', 'dic'];
    return `${day} de ${months[month - 1]}, ${year}`;
};
export const finCotizacion = (start: string, days: number, periods: number, business = false): string => {
    if (!start) return '';
    const date = new Date(`${start}T12:00:00`);
    let remaining = Math.max(1, days) * Math.max(1, periods) - 1;
    while (remaining > 0) {
        date.setDate(date.getDate() + 1);
        if (!business || ![0, 6].includes(date.getDay())) remaining--;
    }
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
};
